import { get as lodashGet } from "lodash-es";
import { useSearchStore } from "../store/useSearchStore";
import { DEFAULT_SEARCH_CATEGORY } from "../GlobalSearchNext.constants";
import type { SearchCategory } from "../GlobalSearchNext.types";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

const useDefaultSearchCategoriesData = () => {
  const { data: config } = useInstanceConfigQuery();
  const defaultSearchCategories: string[] = lodashGet(
    config,
    "es_configuration.client_config.default_search_categories",
    []
  );

  return defaultSearchCategories;
};

export const useDefaultSearchCategories = () => {
  const {
    setSelectedCategories,
    hasSelectedCategories,
    setHasSelectedCategories
  } = useSearchStore();

  const defaultSearchCategories = useDefaultSearchCategoriesData();

  if (!hasSelectedCategories) {
    const searchCategories =
      defaultSearchCategories.length > 0
        ? defaultSearchCategories
        : DEFAULT_SEARCH_CATEGORY;
    setSelectedCategories(searchCategories as SearchCategory[]);
    setHasSelectedCategories(true);
  }
};
